<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="$t('CargoMsg.Cargo_CreditControlInfo')"
      :show-close="true"
      @close="onClose"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="dialogRowData"
        :style="{width:'100%',height:'250px'}"
        no="1"
      />
    </el-dialog>
  </div>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CreditInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    dialogRowData: { type: Array, required: true }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        }
      }
    }
  },
  computed: {},
  created() {
    this.columnDefs = [
      { headerName: this.$t('CargoMsg.Cargo_CreditControlObject'), field: 'creditControlObject', width: 200 },
      {
        headerName: this.$t('Payment.consignationCompany'), field: 'cmpIdx', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_AmountExceeded'), field: 'isAmountExceeded', width: 140,
        cellRenderer: (params) => {
          return ColumnUtils.yesOrNoFun(params.value)
        } },
      { headerName: this.$t('CargoMsg.Cargo_DateExceeded'), field: 'isDateExceeded', width: 140,
        cellRenderer: (params) => {
          return ColumnUtils.yesOrNoFun(params.value)
        } }
    ]
  },
  beforeMount() {
  },
  methods: {
    onClose() {
      this.$emit('onClose')
    }
  }
}
</script>
